"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = exports.ResponseDataTypes = exports.ResponseTypes = exports.RequestType = void 0;
const axios_1 = __importDefault(require("axios"));
const Utils_1 = require("@/Utils");
const Constants_1 = require("app/Constants");
let controller;
var RequestType;
(function (RequestType) {
    RequestType["PUT"] = "put";
    RequestType["POST"] = "post";
    RequestType["PATCH"] = "patch";
    RequestType["DELETE"] = "delete";
})(RequestType = exports.RequestType || (exports.RequestType = {}));
var ResponseTypes;
(function (ResponseTypes) {
    ResponseTypes[ResponseTypes["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    ResponseTypes[ResponseTypes["OK"] = 200] = "OK";
    ResponseTypes[ResponseTypes["FORBIDDEN"] = 403] = "FORBIDDEN";
    ResponseTypes[ResponseTypes["NOT_FOUND"] = 404] = "NOT_FOUND";
})(ResponseTypes = exports.ResponseTypes || (exports.ResponseTypes = {}));
var ResponseDataTypes;
(function (ResponseDataTypes) {
    ResponseDataTypes["BLOB"] = "blob";
    ResponseDataTypes["JSON"] = "json";
})(ResponseDataTypes = exports.ResponseDataTypes || (exports.ResponseDataTypes = {}));
axios_1.default.defaults.withCredentials = true;
const request = (slug, requestType, body, customAbortSignal, withoutAbortController, responseType = ResponseDataTypes.JSON, customLanguage, extraHeaders) => {
    let customSlug;
    if (customAbortSignal) {
        customSlug = customAbortSignal;
    }
    else {
        customSlug = slug.split('?').shift();
    }
    if (!controller)
        controller = {};
    if (controller[customSlug]) {
        controller[customSlug].abort();
    }
    controller[customSlug] = new AbortController();
    const baseUrl = (0, Utils_1.getHostUrl)();
    const requestOptions = {
        withCredentials: true,
        headers: Object.assign({ 'Accept-Language': customLanguage || (0, Utils_1.getLanguage)() }, extraHeaders),
        responseType: responseType
    };
    if (!withoutAbortController) {
        requestOptions.signal = controller[customSlug].signal;
    }
    axios_1.default.interceptors.response.use(response => {
        const requestUrl = response.config.url;
        if (requestUrl.toLowerCase().includes(Constants_1.UserEndpoints.LOGOUT)) {
            return response;
        }
        const expirationInMinutesStr = localStorage.getItem(Constants_1.LocalStorage.EXPIRATION_IN_MINUTES);
        const expirationTimeStr = localStorage.getItem(Constants_1.LocalStorage.EXPIRATION_TIME);
        if (!expirationInMinutesStr || !expirationTimeStr) {
            return response;
        }
        const expirationInMinutes = parseInt(expirationInMinutesStr, 10);
        const newExpirationTime = Date.now() + expirationInMinutes * 60 * 1000;
        localStorage.setItem(Constants_1.LocalStorage.EXPIRATION_TIME, newExpirationTime.toString());
        return response;
    }, error => {
        return Promise.reject(error);
    });
    const url = `${baseUrl}${slug}`;
    switch (requestType) {
        case RequestType.PUT:
            return axios_1.default.put(url, body, requestOptions);
        case RequestType.PATCH:
            return axios_1.default.patch(url, body, requestOptions);
        case RequestType.DELETE:
            return axios_1.default.delete(url, Object.assign(Object.assign({}, body), requestOptions));
        case RequestType.POST:
            return axios_1.default.post(url, body, requestOptions);
        default:
            return axios_1.default.get(url, requestOptions);
    }
};
exports.request = request;
